export const UPDATE_DEVICE_SETTING = 'UPDATE_DEVICE_SETTING'

export const UPDATE_DEVICE_SETTING_DIARY_INTERESTED_ENTITIES = 'UPDATE_DEVICE_SETTING_DIARY_INTERESTED_ENTITIES'
export const UPDATE_DEVICE_SETTING_DIARY_VIEW_IMAGES = 'UPDATE_DEVICE_SETTING_DIARY_VIEW_IMAGES'
